export const shortenContent = (content: string) => {

    const words = content?.split(/\s+/).slice(0, 50) || [];
    return words.join(' ') + (words.length === 50 ? '…' : '');
};

export const shortenContent10 = (content: string) => {

    const words = content?.split(/\s+/).slice(0, 10) || [];
    return words.join(' ') + (words.length === 10 ? '…' : '');
};
